import { getABNVariant, getABNVariantFrom } from '~/src/helpers/abn-tests';

const AUTHORIZATION_SSO = {
    testName: 'authorization_sso',
    variants: {
        on: 'authorization_sso_on',
        off: 'authorization_sso_off',
    },
};

const isSso = (abnTests?: string, defaultVariants?: string) => abnTests
    ? getABNVariantFrom(AUTHORIZATION_SSO.testName, abnTests, defaultVariants) === AUTHORIZATION_SSO.variants.on
    : getABNVariant(AUTHORIZATION_SSO.testName) === AUTHORIZATION_SSO.variants.on;

export default isSso;
